import React from 'react';

import JsonDiffViewer from '@/features/json-diff-viewer';
import { VariableInfo } from '@/lib/PlannerDTOs';
import { parse, prettifyJSON } from '@/utils/json';

interface JSONWrapperProps {
  previousVariable: VariableInfo;
  currentVariable: VariableInfo;
}

const JSONWrapper = ({
  previousVariable,
  currentVariable,
}: JSONWrapperProps) => {
  if (
    previousVariable?.metadata?.jsonSchema ===
    currentVariable?.metadata?.jsonSchema
  )
    return null;

  const previousSchema = previousVariable?.metadata?.jsonSchema
    ? prettifyJSON(parse(previousVariable?.metadata?.jsonSchema))
    : '';
  const currentSchema = currentVariable?.metadata?.jsonSchema
    ? prettifyJSON(parse(currentVariable?.metadata?.jsonSchema))
    : '';

  return (
    <JsonDiffViewer
      oldValue={previousSchema}
      newValue={currentSchema}
      title={currentVariable?.name}
    />
  );
};

export default JSONWrapper;
